import { render, staticRenderFns } from "./qandaDetail.vue?vue&type=template&id=35ab2b78&scoped=true&"
import script from "./qandaDetail.vue?vue&type=script&lang=js&"
export * from "./qandaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab2b78",
  null
  
)

export default component.exports